import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Sparkle, Users, Clock } from "@phosphor-icons/react";

export default function ScarcityBanner() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats/signups").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats || !stats.active) return null;

  return (
    <div className="bg-gradient-to-r from-midnight via-midnight to-black text-bone" data-testid="scarcity-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex flex-wrap items-center justify-center gap-3 text-xs md:text-sm">
        <Sparkle size={16} weight="fill" className="text-gold flex-shrink-0" />
        <span className="tracking-widest uppercase text-gold font-medium">Launch Offer</span>
        <span className="opacity-90">
          First 100 users get <b className="text-gold">20% off</b> their first stay.
        </span>
        <span className="inline-flex items-center gap-1 bg-white/10 px-3 py-1 rounded-full">
          <Users size={12} weight="fill" className="text-emerald-300" />
          <b>{stats.remaining_slots}</b> slots left
        </span>
        <a href="/register" className="inline-flex items-center gap-1 bg-gold text-midnight font-semibold px-3 py-1 rounded-full hover:bg-gold-hover transition-colors" data-testid="scarcity-claim-btn">
          <Clock size={12} weight="bold" /> Claim mine
        </a>
      </div>
    </div>
  );
}
